// Angular imports
import { Component, OnDestroy, OnInit } from '@angular/core';

// 3rd party imports
import { Subscription } from 'rxjs';

// CC-Common imports
import { Utils } from 'cc-common';

// Service imports
import { CiraHelpService } from '../../../_services/shared-services/cira-help.service';
import { ContextManagerService } from '../../../_services/data-services/context-manager.service';

// Constant imports
import { ContactConstants } from '../../../_constants/contact-constants';

// Model imports
import { PropertyCommunityInfoResultDto } from '../../../_models/property-community-info-result-dto';

@Component({
    selector: 'app-internal-user-contact-us',
    templateUrl: './internal-user-contact-us.component.html',
    styleUrls: ['./internal-user-contact-us.component.scss']
})
export class InternalUserContactUsComponent implements OnInit, OnDestroy {
    contactUsPhone: string = ContactConstants.contactUsPhone;
    contactUsPhoneDisplayText: string = ContactConstants.contactUsPhoneDisplayText;
    contactEmail: string = ContactConstants.contactUsEmail;
    supportUrl = ContactConstants.contactSupportUrl;
    ideaCenterUrl: string = ContactConstants.contactIdeaCenterUrl;

    cirahelpUrl: string;
    selectedContext: PropertyCommunityInfoResultDto;
    contextChangeSubscription: Subscription;

    constructor(
        private readonly ciraHelpService: CiraHelpService,
        private readonly contextManagerService: ContextManagerService
    ) {}

    ngOnInit(): void {
        this.updateSelectedContext();
        this.contextChangeSubscription = this.contextManagerService
            .getContext()
            .subscribe(this.updateSelectedContext.bind(this));
    }

    ngOnDestroy(): void {
        if (Utils.notNullAndDefined(this.contextChangeSubscription)) {
            this.contextChangeSubscription.unsubscribe();
        }
    }

    onTileClick(helpUrl: string): void {
        if (Utils.notNullOrEmpty(helpUrl)) {
            window.open(helpUrl, '_blank').focus();
        }
    }

    private updateSelectedContext(): void {
        this.selectedContext = this.contextManagerService.getSelectedContext();
        this.updateCiraHelpLink();
    }

    private updateCiraHelpLink(): void {
        let communityId = null;
        if (Utils.notNullAndDefined(this.selectedContext)) {
            communityId = this.selectedContext.communityId;
        }
        this.cirahelpUrl = this.ciraHelpService.getHelpLink(null, null, communityId);
    }
}
